// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.query-graph .react-flow__pane {
  background: #fdfdfd;
}

.query-graph .react-flow__handle {
  background-color: transparent;
  pointer-events: none;
}

.query-graph .react-flow__pane,
.query-graph .react-flow__edge,
.query-graph .react-flow__node {
  cursor: default;
}

.query-graph .react-flow__edge-textbg {
  opacity: .7;
  fill: white;
  stroke: #777;
}

.query-graph .react-flow__edge-text {
  font-size: .6em;
}

.query-graph .react-flow__edge.qg-label-highlighted .react-flow__edge-text {
  fill: hsl(309, 84%, 36%);
}


.query-graph .react-flow__edge.qg-crosslink .react-flow__edge-path {
  stroke: #ccc;
  stroke-dasharray: 4 4;
  transition-property: stroke, stroke-width, stroke-dasharray;
  transition-duration: .5s;
}

.query-graph .react-flow__edge.qg-crosslink:hover .react-flow__edge-path,
.query-graph .react-flow__edge.qg-crosslink:focus .react-flow__edge-path {
  stroke: hsl(309, 84%, 36%);
  stroke-width: 1.5px;
  stroke-dasharray: 6 2;
}
`, "",{"version":3,"sources":["webpack://./../query-graphs/lib/ui/QueryGraph.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,YAAY;EACZ,qBAAqB;EACrB,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".query-graph .react-flow__pane {\n  background: #fdfdfd;\n}\n\n.query-graph .react-flow__handle {\n  background-color: transparent;\n  pointer-events: none;\n}\n\n.query-graph .react-flow__pane,\n.query-graph .react-flow__edge,\n.query-graph .react-flow__node {\n  cursor: default;\n}\n\n.query-graph .react-flow__edge-textbg {\n  opacity: .7;\n  fill: white;\n  stroke: #777;\n}\n\n.query-graph .react-flow__edge-text {\n  font-size: .6em;\n}\n\n.query-graph .react-flow__edge.qg-label-highlighted .react-flow__edge-text {\n  fill: hsl(309, 84%, 36%);\n}\n\n\n.query-graph .react-flow__edge.qg-crosslink .react-flow__edge-path {\n  stroke: #ccc;\n  stroke-dasharray: 4 4;\n  transition-property: stroke, stroke-width, stroke-dasharray;\n  transition-duration: .5s;\n}\n\n.query-graph .react-flow__edge.qg-crosslink:hover .react-flow__edge-path,\n.query-graph .react-flow__edge.qg-crosslink:focus .react-flow__edge-path {\n  stroke: hsl(309, 84%, 36%);\n  stroke-width: 1.5px;\n  stroke-dasharray: 6 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
